import { render } from "./TabPanel.vue?vue&type=template&id=9bacbfc2"
import script from "./TabPanel.vue?vue&type=script&lang=js"
export * from "./TabPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TabPanel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9bacbfc2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9bacbfc2', __exports__)) {
    api.reload('9bacbfc2', __exports__)
  }
  
  module.hot.accept("./TabPanel.vue?vue&type=template&id=9bacbfc2", () => {
    api.rerender('9bacbfc2', render)
  })

}


export default __exports__